"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefinitionListDescription = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const StyledDefinitionDescription = components_core_1.styled.dd `
  display: inline;
  margin: 0;
`;
function DefinitionListDescription({ children }) {
    return (react_1.default.createElement(StyledDefinitionDescription, { className: "definition-list-description-container" }, children));
}
exports.DefinitionListDescription = DefinitionListDescription;
